<template>
  <div>
    <div class="intro-y flex items-center h-10">
      <h2 class="text-lg font-medium truncate mr-3">
        Cases History <small>(5 Years)</small>
      </h2>
      <BarChart2Icon class="report-box__icon text-theme-1" />
    </div>
    <div class="intro-y box p-5 mt-3">
      <div class="flex">
        <DownloadChart
          @click="downloadCanvas('casesYearChart', 'titleYearChart')"
        />
      </div>
      <div ref="casesYearChart">
        <h3 ref="titleYearChart" class="hidden mt-4 text-lg">
          Corruption Cases By Year
        </h3>
        <BarChart
          :width="width"
          :height="height"
          :chart-data="data"
          :options="options"
        />
        <h3 ref="title" class="hidden mt-4 text-lg text-center">
          Cases History
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import StackedBarChart from "@/components/StackedBarChart";

export default {
  props: {
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      decided: [0, 0, 0, 0, 0],
      ontrial: [0, 0, 0, 0, 0]
    };
  },
  computed: {
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    },
    ontrial_counts() {
      return Object.values(this.ontrial);
    },
    decided_counts() {
      return Object.values(this.decided);
    },
    this_year() {
      return new Date().getFullYear();
    },
    data() {
      return {
        labels: Object.keys(this.ontrial),
        datasets: [
          {
            label: "Decided",
            backgroundColor: "#339966",
            data: this.decided_counts
          },
          {
            label: "On Trial",
            backgroundColor: "#b6142c",
            data: this.ontrial_counts
          }
        ]
      };
    },
    options() {
      return {
        legend: {
          display: true
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              ticks: {
                fontSize: "12",
                fontColor: this.$store.state.main.darkMode
                  ? "#718096"
                  : "#777777"
              },
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                fontSize: "12",
                fontColor: this.$store.state.main.darkMode
                  ? "#718096"
                  : "#777777",
                callback: function(value) {
                  return value;
                }
              },
              gridLines: {
                color: this.$store.state.main.darkMode ? "#718096" : "#D8D8D8",
                zeroLineColor: this.$store.state.main.darkMode
                  ? "#718096"
                  : "#D8D8D8",
                display: true
              }
            }
          ]
        }
      };
    }
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.run();
      }
    }
  },
  mounted() {
    this.run();
  },
  methods: {
    run() {
      let param = {
        ...this.filterParams
      };
      let url = `${window.host}/api/cases-years`;

      axios
        .get(url, {
          params: param
        })
        .then(response => {
          if (response.data) {
            this.ontrial = response.data.ontrial;
            this.decided = response.data.decided;
          }
        });
    }
  }
};
</script>
